import { cache } from 'react';
import { buildAPIUrl } from '.';
import { CognitiveFilterRequestModel, CognitiveSearchResultModel } from '@/types';

export const searchMedia = cache(
  async (filterRequest: CognitiveFilterRequestModel): Promise<CognitiveSearchResultModel<any>> => {
    const dataResponse = await fetch(`${await buildAPIUrl()}/umbraco/Api/MediaListing/Search`, {
      method: 'POST',
      body: JSON.stringify(filterRequest),
    });
    return dataResponse.json();
  },
);
